export default __webpack_public_path__ + "images/cyber_lock.jpg";